module.exports = __webpack_public_path__ + "img/QC.a372cf87.png";